import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

/* ====================================
# スクロールロック制御
==================================== */

// スクロールをロックする関数
export const lockScroll = () => {
  const body = document.body;
  const scrollY = window.scrollY;

  body.style.position = 'fixed';
  body.style.top = `-${scrollY}px`;
  body.style.width = '100%';
  body.classList.add('scroll-locked');
};

// スクロールロックを解除する関数
export const unlockScroll = () => {
  const body = document.body;
  const scrollY = body.style.top;

  body.style.position = '';
  body.style.top = '';
  body.style.width = '';
  body.classList.remove('scroll-locked');

  if (scrollY) {
    window.scrollTo(0, parseInt(scrollY || '0') * -1);
    // スクロール位置変更後にScrollTriggerをリフレッシュ
    setTimeout(() => {
      if (typeof ScrollTrigger !== 'undefined') {
        ScrollTrigger.refresh();
      }
    }, 100);
  }
};